// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JZBw0HPflJ6KpI9SAgNl {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/pages/waitlist-update/dashboard/components/manual-contact.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC","sourcesContent":[".content {\n    margin-top: 16px;\n    display: flex;\n    justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `JZBw0HPflJ6KpI9SAgNl`
};
export default ___CSS_LOADER_EXPORT___;
